import { TextSelection } from '@atlaskit/editor-prosemirror/state';
export function handleEditorFocus(view) {
  if (view.hasFocus()) {
    return;
  }
  return window.setTimeout(function () {
    if (view.hasFocus()) {
      return;
    }
    if (!window.getSelection) {
      view.focus();
      return;
    }
    var domSelection = window.getSelection();
    if (!domSelection || domSelection.rangeCount === 0) {
      view.focus();
      return;
    }
    var range = domSelection.getRangeAt(0);
    // if selection is outside editor focus and exit
    if (range.startContainer.contains(view.dom)) {
      view.focus();
      return;
    }
    // set cursor/selection and focus
    var anchor = view.posAtDOM(range.startContainer, range.startOffset);
    var head = view.posAtDOM(range.endContainer, range.endOffset);
    // if anchor or head < 0 focus and exit
    if (anchor < 0 || head < 0) {
      view.focus();
      return;
    }
    var selection = TextSelection.create(view.state.doc, anchor, head);
    var tr = view.state.tr.setSelection(selection);
    view.dispatch(tr);
    view.focus();
  }, 0);
}